const constants = {
  MCQ_MESSAGE_CONSTRAINTS: {
    MIN_ALLOWED_OPTIONS: 1,
    MAX_ALLOWED_OPTIONS: 5,
  },
  MAX_LENGTH_CONSTRAINTS: {
    OPTION_TEXT: 150,
    CANNED_VALUE: 3,
  },
  CANNED_MESSAGES: [
    {
      text: "Call me at next available opportunity.",
      isEditable: false,
      type: "none",
    },
    {
      text: "How many pallet spaces left on the trailer?",
      isEditable: false,
      type: "none",
    },
    { text: "Where to next?", isEditable: false, type: "none" },
    {
      text: "When will you be completed with deliveries?",
      isEditable: false,
      type: "none",
    },
    {
      text: "When will you be completed with pickups?",
      isEditable: false,
      type: "none",
    },
    { text: "How many swaps are ready?", isEditable: false, type: "none" },
    { text: "Need an ETA for ________?", isEditable: true, type: "select" },
    { text: "When does ________ close?", isEditable: true, type: "select" },
    {
      text: "Who is contact for ________?",
      isEditable: true,
      type: "select",
    },
    {
      text: "Return to terminal, put in door ________?",
      isEditable: true,
      type: "number",
    },
  ]
};

export default constants;
